module.exports = __webpack_public_path__ + "img/phone-haulage-2.8e3bc002.png";